type TabLabelProps = {
	badge?: string | number;
	subtitle?: string;
	title: string;
};

export const TabLabel = ({ badge, subtitle, title }: TabLabelProps) => (
	<>
		<span>
			{title}
			{!!badge && (
				<span className={'MuiTabItem-tag MuiTabItem-tag-info'}>
					{badge}
				</span>
			)}
		</span>
		{subtitle && <span className={'MuiTabItem-subLabel'}>{subtitle}</span>}
	</>
);
